__turbopack_context__.v({
  "selectUser__chooseNewEntityItem": "SelectUser-module__-etC-q__selectUser__chooseNewEntityItem",
});
